import { selectAssignment } from '@redux/experiments/selectors/index';
import type { State } from 'types/redux';

const isEligibleForMarkAsBookedLiteStorefronts = (state: State): boolean => {
	const purchaseStatus = state.vendor.vendorRaw?.purchaseStatus;

	return purchaseStatus === 'UNPAID' || purchaseStatus === 'FREEMIUM';
};

export const markAsBookedLiteStorefrontsSelector = (state: State) => {
	if (!isEligibleForMarkAsBookedLiteStorefronts(state)) return null;
	return selectAssignment(state, ['markAsBookedLiteStorefronts']);
};
